import { send } from '../../../../../../src/network';
import { type PaginatedCustomerFoodFeedbackList } from '../../../../../../src/types/PaginatedCustomerFoodFeedbackList';

export type Params = {
  bundle?: number;
  limit?: number;
  offset?: number;
  order?: number;
  pairing?: number;
  product?: number;
};

export async function getApiV2CustomersSelfFoodFeedback(params: Params = {}) {
  const queryParams = new URLSearchParams();

  if (params.bundle !== undefined) {
    queryParams.append('bundle', params.bundle.toString());
  }

  if (params.limit !== undefined) {
    queryParams.append('limit', params.limit.toString());
  }

  if (params.offset !== undefined) {
    queryParams.append('offset', params.offset.toString());
  }

  if (params.order !== undefined) {
    queryParams.append('order', params.order.toString());
  }

  if (params.pairing !== undefined) {
    queryParams.append('pairing', params.pairing.toString());
  }

  if (params.product !== undefined) {
    queryParams.append('product', params.product.toString());
  }

  return await send<PaginatedCustomerFoodFeedbackList>({
    path: `/api/v2/customers/self/food_feedback/`,
    method: 'GET',
    query: queryParams,
  });
}
